/**
 * Fill classes for meter tones (MeterTone). A non-component module so the
 * meters share one map and react-refresh stays warning-free.
 */
import type { MeterTone } from './types'

export const TONE_BG: Record<MeterTone, string> = {
  crit: 'bg-sev-crit',
  high: 'bg-sev-high',
  med: 'bg-sev-med',
  low: 'bg-sev-low',
  strong: 'bg-text-primary',
  off: 'bg-cat-off',
  baseline: 'bg-cat-baseline',
  bpa: 'bg-cat-bpa',
  identity: 'bg-cat-identity',
  secure: 'bg-cat-secure',
}

export const TONE_TEXT: Record<MeterTone, string> = {
  crit: 'text-sev-crit',
  high: 'text-sev-high',
  med: 'text-sev-med',
  low: 'text-sev-low',
  strong: 'text-text-primary',
  off: 'text-cat-off',
  baseline: 'text-cat-baseline',
  bpa: 'text-cat-bpa',
  identity: 'text-cat-identity',
  secure: 'text-cat-secure',
}
